import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  z-index: 11;
  position: absolute;
  width: 100%;
  max-width: 600px;
  height: 100vh;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  top: 0;
  left: 0;
`;

const Content = styled.div`
    width: 100%;
    border-radius: 30px;
    box-shadow: 0px 9px 15px 0px #00000033;
    margin: auto;
    overflow-y: hidden;
    background-color: white;
    padding: 30px 20px;
    margin: 20px;
    display: flex;
    flex-direction: column;

    button {
        width: 100%;
        margin-top: auto;
    }
`;

const CenterData = styled.div`
    margin-top: auto;
    color: ${theme.textDark};
    text-align: center;

    h5 {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 400;
    }

    span {
        font-size: 16px;
        font-weight: 400;
    }

`;

export { Container, Content, CenterData };